"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Chat.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Chat = function Chat(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 198.16 189.62"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Chat Icon"), _react2.default.createElement("path", {
    className: "chat",
    d: "M176.68 0H67.43a21.5 21.5 0 0 0-21.48 21.48v15.65H21.47A21.5 21.5 0 0 0 0 58.6v66a21.5 21.5 0 0 0 21.48 21.48h19.78l-.35 43.53 36.63-43.52h53.18a21.51 21.51 0 0 0 21.34-19l21.39 25.42-.35-43.53h3.57a21.5 21.5 0 0 0 21.48-21.48v-66A21.5 21.5 0 0 0 176.68 0zm-9.6 135.21l-14.87-17.67V58.6a21.5 21.5 0 0 0-21.48-21.48H52.19V21.48A15.25 15.25 0 0 1 67.43 6.24h109.25a15.25 15.25 0 0 1 15.23 15.23v66a15.25 15.25 0 0 1-15.23 15.23h-9.87zm-21.12-15.39v4.79a15.25 15.25 0 0 1-15.23 15.23H74.64l-27.35 32.5.25-32.5H21.47a15.25 15.25 0 0 1-15.23-15.23v-66A15.25 15.25 0 0 1 21.47 43.4h109.26a15.25 15.25 0 0 1 15.23 15.2v61.21z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Chat;